export const validateTextFieldValue = (value: string) => {
  return value.trimStart().replace(/\s\s+/g, ' ');
};

export const validateMultilineTextFieldValue = (value: string) => {
  // Trim leading spaces on each line, but preserve line breaks
  return value
    .split('\n')
    .map(line => line.trimStart().replace(/\s\s+/g, ' '))
    .join('\n');
};

